"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
const request_1 = require("./request");
const createClient = (url, opts) => {
    return new request_1.GraphQLClient(url, opts);
};
exports.createClient = createClient;
//# sourceMappingURL=client.js.map